module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/frontmatter2"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/frontmatter3"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/frontmatter4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_vm._v("THE STORIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("GEORGE ANDERSON")])]), _vm._v(" | "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("The Bite Is On")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CAPTAIN DAN AYO")])]), _vm._v(" | "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_vm._v("The Mayor of Dulac Is Waiting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("GARY BORGER")])]), _vm._v(" | "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter3"
    }
  }, [_vm._v("Learning to Drive on the Left")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CONWAY BOWMAN")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shark 911")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("PAUL BRUUN")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why I Hate Steelheading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHAPPIE CHAPMAN")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Right-Hand-Reach Mend")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("MIKE COPITHORNE")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laughter in the Canyon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JEFF CURRIER")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hunt for the Mighty Mahseer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("RALPH CUTTER")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fly Fishing 3,000 Feet under the Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JACK DENNIS")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Of Coffee Cans and Kiwis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JOHN ECKLUND")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 2X Pool")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("LANCE EGAN")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Magic Carpet and the Mud Dauber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CRAIG FELLIN")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fishing with Ed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("MOLLIE FITZGERALD")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reeling on the Alta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("SAM FLICK")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Men Out, Hatch on First")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("DAVID FOSTER")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nature’s Call")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("RICK GAFFNEY")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fish That Couldn’t Be Caught")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CINDY GARRISON")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbels and Tigers and Hippos, Oh My!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JACK GARTSIDE")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Queen’s Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHARLES GAUVIN")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Pain in the Neck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("BRIAN GROSSENBACHER")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Risky Shot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JENNY GROSSENBACHER")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Good Case for Barbless Hooks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("PETER KAMINSKY")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Albies and the Apple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("PUDGE KLEINKAUF")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beginners")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("MEL KRIEGER")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hooking Up with the General")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JOEL LA FOLLETTE")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bullish on Bull Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("MIKE LAWSON")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hooked on Fly Fishing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("SCOTT LEON")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hurricane Hatter and Typhoon Leon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("MACAULEY LORD")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man One, Beaver Zero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("TOM MONTGOMERY")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toasting the Glenfiddich")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("GORDON MOORE")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Island Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("BRIAN O’KEEFE")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Up the River without a Dory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("MARK O’MEARA")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Fish for a Tiger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("LEIGH PERKINS")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother Knows Best")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("PERK PERKINS")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Trout Round-Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("ROSS PURNELL")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna from Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("TIM PURVIS")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meteors, Kamchatka-Style")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("TIM RAJEFF")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salmon by Pulley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("PATTY REILLY")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luck of the Irish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("ED RICE")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One for Thirty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("DON ROBERTS")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.M. Whiteout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JIM SCOTT")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Surface Action")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("BEAVER SHRIVER")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cut!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JOHN SIMMS")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Money Hole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("J. W. SMITH")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boxing with Bears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("BILL TAYLOR")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three’s the Charm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("DONNA TEENY")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Birthday Tarpon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JIM TEENY")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Gaffe with the Gaff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("HEATHER TEMPLETON")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Can’t Believe You Missed That Freakin’ Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("JEAN WILLIAMS")])]), _vm._v(" | "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Half-Rod Education")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0